var React = require('react');

function Divider (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"profile","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","transform":"translate(-294.000000, -118.000000)"},React.createElement("g",{"id":"divider","transform":"translate(295.000000, 118.000000)","stroke":"#384653"},[React.createElement("polyline",{"id":"Triangle","points":"0 5 4.5 0 4.5 0 9 5","key":0}),React.createElement("polyline",{"id":"Triangle-Copy","points":"9 5 13.5 0 13.5 0 18 5","key":1}),React.createElement("polyline",{"id":"Triangle-Copy-2","points":"18 5 22.5 0 22.5 0 27 5","key":2}),React.createElement("polyline",{"id":"Triangle-Copy-3","points":"27 5 31.5 0 31.5 0 36 5","key":3})])));
}

Divider.displayName = "Divider";

Divider.defaultProps = {"width":"38","height":"5","viewBox":"0 0 38 5","version":"1.1"};

module.exports = Divider;

Divider.default = Divider;



//////////////////
// WEBPACK FOOTER
// ./src/components/WorksListSection/divider.svg
// module id = 369
// module chunks = 35884836353623